export default "__VITE_ASSET__BIom58Iu__"